// import Sass
import './style.scss';

// AlertBox
const allAlert = document.querySelectorAll('.wp-block-abb-alert-box');

Object.values(allAlert).map(alert => {
    const alertEl = document.getElementById(alert.id);

    const alertCloseEl = document.querySelector(`#${alert.id} .abbAlertBox .alert .alertClose`);

    alertCloseEl && alertCloseEl.addEventListener('click', () => {
        alertEl.classList.add('transformHidden');

        setTimeout(() => {
            alertEl.style.display = 'none';
        }, 400);
    });
});